import i18n from "components/i18n/i18n";
import * as Handlebars from "handlebars";

export default function(i18nKey: string) {
    const result = i18n.instance.t(i18nKey);
    return new Handlebars.SafeString(result);
}
